<template>
	<fieldset>
		<legend v-if="legendLabel">
			{{ legendLabel }}
			<font-awesome-icon
				class="tooltip-target b360-form-icon"
				:icon="['fal', 'question-circle']"
				v-tooltip="{
					content: tooltip,
					trigger: 'hover click',
					placement: 'top-end',
				}"
				v-if="tooltip"
			/>
		</legend>
		<div class="radio-button" v-for="(radio, index) in radioGroup" :key="index">
			<input
				type="radio"
				:name="radio.name"
				:value="radio.value"
				:id="`${radio.section}-${radio.name}-${radio.id}`"
				:checked="radio.checked"
				@click="!disabled ? toggleRadio($event) : ''"
				:disabled="disabled"
			/>
			<label
				:class="{ disabled: disabled, enabled: !disabled }"
				:for="`${radio.section}-${radio.name}-${radio.id}`"
				tabindex="0"
			>
				<span v-if="radio.labelPrefix" class="label-prefix">{{
					radio.labelPrefix
				}}</span
				>&nbsp;
				<span>{{ radio.label }}</span>
			</label>
		</div>
	</fieldset>
</template>

<script>
export default {
	name: 'FormRadioButtons',
	props: {
		legendLabel: String,
		tooltip: String,
		radioGroup: Array,
		disabled: Boolean,
		isRateWatchPricing: Boolean,
		forClientConnect: Boolean,
	},
	mounted() {
		document.addEventListener('keydown', (e) => {
			if (
				document.activeElement.tagName === 'LABEL' &&
				e.code.includes('Enter')
			) {
				document.activeElement.click();
			}
		});
	},
	methods: {
		toggleRadio: function (event) {
			if (this.forClientConnect) {
				return this.$emit('handleInput', { value: event.target.value });
			}

			// if these radios are being use for rateWatch inside of PC just emit
			if (this.isRateWatchPricing)
				return this.$emit('handle-input', { value: this.radioGroup.checked });

			const currentRadioIndex = event.currentTarget.id.slice(-1);
			const otherRadioIndex = currentRadioIndex === '1' ? '0' : '1';
			this.$el.__vue__.$options.propsData.radioGroup[
				currentRadioIndex
			].checked = true;
			this.$el.__vue__.$options.propsData.radioGroup[
				otherRadioIndex
			].checked = false;
			this.$emit('handle-input', { value: event.target.value === 'true' });
		},
	},
};
</script>

<style lang="scss" scoped>
fieldset {
	display: flex;
	flex-direction: column;
	border: none;
	@include rem(margin, 0 0 20px 0);
	padding: 0;
	border-bottom: $b360-border-width-thin solid $border-color-light;

	legend {
		@include typo--roboto__medium;
		color: $subheader-color;
		@include rem(margin-bottom, 10px);
	}
}

input[type='radio'] {
	display: none;
}

.radio-button {
	margin-bottom: 12px;

	&:last-child {
		margin-bottom: 20px;
	}

	label {
		position: relative;
		display: inline-flex;
		font-size: 15px;
		line-height: 1;
		align-items: center;
		outline: none;

		/*18px width of fake radio + 10px distance between fake radio and text*/
		@include rem(padding-left, 28px);

		&::before,
		&::after {
			position: absolute;
			content: '';

			/*Needed for the line-height to take effect*/
			display: inline-flex;
		}
		&.enabled {
			cursor: pointer;
		}
		&.disabled {
			cursor: not-allowed;
		}

		&::before {
			box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
			border-radius: $b360-border-radius-circle;
			width: 18px;
			height: 18px;
			left: 0px;
		}
	}

	input:checked + label {
		&.disabled {
			cursor: not-allowed;
			&::before {
				background-color: $b360-color--gray__darker;
				box-shadow: unset;
			}
		}

		&::after {
			height: 6px;
			width: 6px;
			border-radius: $b360-border-radius-circle;
			background-color: $white;
			left: 6px;
		}

		&.enabled {
			cursor: pointer;
			&::before {
				background-color: $brand-blue;
				box-shadow: unset;
			}
		}
	}

	.label-prefix {
		font-weight: 500;
		@include rem(padding-bottom, 2px);
	}
}
</style>
